export default {
  title: 'Zmieniono podczas edycji',
  descriptionConflicts: 'Te dane zostały w międzyczasie zapisane. Kliknij wartość, którą chcesz zachować, w każdym polu, które również zmieniłeś.',
  descriptionServerChanges: 'Te dane zostały w międzyczasie zapisane. Te zmiany zostaną zastosowane razem z Twoimi. Cofnij te, których nie chcesz zachować.',
  notSaved: 'Niezapisane',
  field: 'Pole',
  keepAll: 'Zachowaj wszystkie wartości',
  keeping: 'Zachowywane',
  you: 'Ty',
  combined: 'Zachowaj obie (najpierw wersja na serwerze)',
  added: 'Dodano',
  removed: 'Usunięto',
  missing: 'Brak',
  value: 'Wartość',
  positionStart: 'Na początku',
  positionAfter: 'Po {item}',
  resolvedCount: 'Rozwiązane konflikty: {resolved} z {total}',
  saveDisabled: 'Pozostałe pola do wyboru wartości: {count}',
  serverChanges: 'Zmiany w wersji na serwerze bez konfliktu: {count}',
  show: 'Pokaż zmiany',
  hide: 'Ukryj zmiany',
  revert: 'Cofnij zmianę',
  restore: 'Przywróć zmianę',
  reverted: 'Twoja wartość zostaje zachowana',
  cancelTooltip: 'Odrzuć swoje zmiany i kontynuuj edycję wersji na serwerze',
  latestMissing: 'Te dane zostały usunięte na serwerze podczas edycji. Nie można zapisać Twoich zmian.',
  version: {
    original: 'Pierwotna wersja',
    latest: 'Wersja na serwerze',
    edited: 'Twoja wersja',
  },
};
